<section class="page-section section-auth">

    <div class="background-effect"></div>

    <auth-header></auth-header>

    <div class="ui-view-main">

        <div class="container">
            <div class="row">
                <div class="col col-6 col-offset-3">
                    <h2 class="align-center">
                        <span [innerHTML]="'auth.headers.register' | translate"></span>
                    </h2>
                </div>
            </div>

            <div class="row">
                <div class="col col-6 col-offset-3">

                    <p class="team-name">{{ team.name }}</p>
                    <form (ngSubmit)="onSubmit()">

                        <div class="form-group">
                            <label for="activation-code" class="label-visible" [innerHTML]="'auth.labels.form.activationcode' | translate"></label>
                            <input
                                    type="text"
                                    id="activation-code"
                                    class="form-control"
                                    name="activation-code"
                                    [disabled]="true"
                                    [(ngModel)]="activationCode.code"
                                    placeholder="{{ 'auth.labels.form.activationcode' | translate }}"
                            />
                        </div>
                        <div class="form-group">
                            <label for="username" [innerHTML]="'auth.labels.form.username' | translate"></label>
                            <input
                                    type="text"
                                    id="username"
                                    class="form-control"
                                    name="username"
                                    [(ngModel)]="user.username"
                                    placeholder="{{ 'auth.labels.form.username' | translate }}"
                                    [minlength]="3"
                                    [maxlength]="100"
                            />
                            <div *ngIf="validationErrors.username">
                                <span *ngFor="let error of validationErrors.username" class="form-validation error">
                                    {{ error | translate }}
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="firstname" [innerHTML]="'auth.labels.form.first_name' | translate"></label>
                            <input
                                    type="text"
                                    id="firstname"
                                    class="form-control"
                                    name="firstname"
                                    [(ngModel)]="user.firstname"
                                    placeholder="{{ 'auth.labels.form.first_name' | translate }}"
                                    [maxlength]="100"
                            />
                            <div *ngIf="validationErrors.firstname">
                                <span *ngFor="let error of validationErrors.firstname" class="form-validation error">
                                    {{ error | translate }}
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="lastname" [innerHTML]="'auth.labels.form.last_name' | translate"></label>
                            <input
                                    type="text"
                                    id="lastname"
                                    class="form-control"
                                    name="lastname"
                                    [(ngModel)]="user.lastname"
                                    placeholder="{{ 'auth.labels.form.last_name' | translate }}"
                                    [maxlength]="100"
                            />
                            <div *ngIf="validationErrors.lastname">
                                <span *ngFor="let error of validationErrors.lastname" class="form-validation error">
                                    {{ error | translate }}
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="email" [innerHTML]="'auth.labels.form.email' | translate"></label>
                            <input
                                    type="text"
                                    id="email"
                                    class="form-control"
                                    name="email"
                                    [(ngModel)]="user.email"
                                    placeholder="{{ 'auth.labels.form.email' | translate }}"
                                    [maxlength]="120"
                            />
                            <div *ngIf="validationErrors.email">
                                <span *ngFor="let error of validationErrors.email" class="form-validation error">
                                    {{ error | translate }}
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="email_confirmation" [innerHTML]="'auth.labels.form.email2' | translate"></label>
                            <input
                                    type="text"
                                    id="email_confirmation"
                                    class="form-control"
                                    name="email_confirmation"
                                    [(ngModel)]="user.email_confirmation"
                                    placeholder="{{ 'auth.labels.form.email2' | translate }}"
                            />
                        </div>
                        <div class="form-group">
                            <label for="password" [innerHTML]="'auth.labels.form.password' | translate"></label>
                            <input
                                    type="password"
                                    id="password"
                                    class="form-control"
                                    name="password"
                                    [(ngModel)]="user.password"
                                    placeholder="{{ 'auth.labels.form.password' | translate }}"
                            />
                            <div passwordToggle
                                 class="show-password"
                                 [elementTargetId]="'password'"
                            >
                                <span class="icon icon-ag-eye"></span>
                            </div>

                            <span class="form-validation" [innerHTML]="'general.form.password.requirements' | translate"></span>

                            <ng-container *ngIf="validationErrors.password">
                                <span *ngFor="let error of validationErrors.password" class="form-validation error">
                                    {{ error | translate }}
                                </span>
                            </ng-container>
                        </div>
                        <div class="form-group">
                            <label for="password_confirmation" [innerHTML]="'auth.labels.form.password2' | translate"></label>
                            <input
                                    type="password"
                                    id="password_confirmation"
                                    class="form-control"
                                    name="password_confirmation"
                                    [(ngModel)]="user.password_confirmation"
                                    placeholder="{{ 'auth.labels.form.password2' | translate }}"
                            />
                            <div passwordToggle
                                 class="show-password"
                                 [elementTargetId]="'password_confirmation'"
                            >
                                <span class="icon icon-ag-eye"></span>
                            </div>

                            <ng-container *ngIf="validationErrors.password_confirmation">
                                <span *ngFor="let error of validationErrors.password_confirmation" class="form-validation error">
                                    {{ error | translate }}
                                </span>
                            </ng-container>
                        </div>

                        <button
                                class="btn-default float-right"
                                type="submit"
                        >
                            <span [innerHTML]="'auth.buttons.register' | translate"></span>
                        </button>

                    </form>
                </div>
            </div>
        </div>
    </div>

</section>
